import { ReactNode } from "react";

/* Prop Types */
interface TableRowProps {
  className?: string;
  children: ReactNode;
  onClick?: () => void;
  onDoubleClick?: () => void;
}

/*
 * TableRow component
 */
export const TableRow = ({ className, children, onClick, onDoubleClick }: TableRowProps) => {
  /* Render */
  return (
    <tr
      onClick={onClick}
      onDoubleClick={onDoubleClick}
      className={`${onClick || onDoubleClick ? "cursor-pointer" : null} hover:bg-base-200 duration-150 ease-out border-b border-base-300 ${className}`}
    >
      {children}
    </tr>
  );
};
